export enum BoxbuttonColorTheme{
    WHITE = 'white',
    GREEN = 'green'
}